const objectFilter = (obj: Record<string, any | undefined>, predicate: (val: any) => any) =>
  Object.fromEntries(Object.entries(obj).filter(predicate));

function removeUndefined(input: Record<string, any | undefined>): Record<string, string> {
  return objectFilter(
    input,
    ([key, value]: [string, string | undefined]) => value !== undefined,
  ) as Record<string, string>;
}

export default removeUndefined;
